<template>
    <div class="prop-box">

        <el-form label-width="auto">
            <el-form-item label="名称">
                <el-input v-model="myBottomTab.name" placeholder="name"></el-input>
            </el-form-item>

            <el-form-item label="类型">
                <el-select v-model="myBottomTab.type">
                    <el-option v-for="item, index in bottomTabOptions" :key="index" :label="item.name"
                        :value="item.value"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="需要登录">
                <el-radio-group v-model="myBottomTab.config.is_need_login">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="黑暗模式">
                <el-radio-group v-model="myBottomTab.config.is_dark">
                    <el-radio :label="1">是</el-radio>
                    <el-radio :label="0">否</el-radio>
                </el-radio-group>
            </el-form-item>

        </el-form>
        <div class="icons">
            <div class="icon-group">
                <el-upload class="icon-uploader" :show-file-list="false"
                    :http-request="(file, fileList) => onUploadIcon(file, 0)">
                    <img v-if="myBottomTab.ignore.icon_select_url" :src="myBottomTab.ignore.icon_select_url"
                        class="icon" />
                    <el-icon v-else class="icon-uploader-plus">
                        <Plus />
                    </el-icon>
                </el-upload>
                <p>选中</p>
            </div>
            <div class="icon-group">
                <el-upload class="icon-uploader" :show-file-list="false"
                    :http-request="(file, fileList) => onUploadIcon(file, 1)">
                    <img v-if="myBottomTab.ignore.icon_normal_url" :src="myBottomTab.ignore.icon_normal_url"
                        class="icon" />
                    <el-icon v-else class="icon-uploader-plus">
                        <Plus />
                    </el-icon>
                </el-upload>
                <p>未选中</p>
            </div>
            <div class="icon-group">
                <el-upload class="icon-uploader" :show-file-list="false"
                    :http-request="(file, fileList) => onUploadIcon(file, 2)">
                    <img v-if="myBottomTab.ignore.icon_select_dark_url" :src="myBottomTab.ignore.icon_select_dark_url"
                        class="icon" />
                    <el-icon v-else class="icon-uploader-plus">
                        <Plus />
                    </el-icon>
                </el-upload>
                <p>选中-黑</p>
            </div>
            <div class="icon-group">
                <el-upload class="icon-uploader" :show-file-list="false"
                    :http-request="(file, fileList) => onUploadIcon(file, 3)">
                    <img v-if="myBottomTab.ignore.icon_normal_dark_url" :src="myBottomTab.ignore.icon_normal_dark_url"
                        class="icon" />
                    <el-icon v-else class="icon-uploader-plus">
                        <Plus />
                    </el-icon>
                </el-upload>
                <p>未选中-黑</p>
            </div>
        </div>

    </div>
</template>

<script>
import { Plus } from '@element-plus/icons-vue'
import { UploadIcon } from '@/request/api'
export default {
    setup() {
    },
    name: "BottomTabBarProp",
    components: {
        Plus
    },
    props: ['bottomTab'],
    data() {
        return {
            myBottomTab: this.bottomTab,
            bottomTabOptions: [
                { name: 'general', value: "general" },
                { name: 'single', value: "single" },
                { name: 'message', value: "message" },
                { name: 'mine', value: "mine" },
            ]
        }
    },
    methods: {
        /**
         * 上传Icon
         * @param {*} what 0-选中 1-默认 2-选中(黑) 3-默认(黑)
         */
        onUploadIcon(file, what) {
            console.log('onUploadIcon', what)
            let formdata = new FormData();
            formdata.append('image', file.file)
            UploadIcon(formdata)
                .then(data => {
                    this.$message.success('上传成功')
                    const imageID = data.imageID
                    const imageUrl = data.image.original
                    switch (what) {
                        case 0:
                            this.myBottomTab.icons.icon_select = imageID
                            this.myBottomTab.ignore.icon_select_url = imageUrl
                            break
                        case 1:
                            this.myBottomTab.icons.icon_normal = imageID
                            this.myBottomTab.ignore.icon_normal_url = imageUrl
                            break
                        case 2:
                            this.myBottomTab.icons.icon_select_dark = imageID
                            this.myBottomTab.ignore.icon_select_dark_url = imageUrl
                            break
                        case 3:
                            this.myBottomTab.icons.icon_normal_dark = imageID
                            this.myBottomTab.ignore.icon_normal_dark_url = imageUrl
                            break
                    }
                })
                .catch(error => {
                    this.$message.error('上传失败')
                    console.log('上传失败', error)
                })
        }

    },
    watch: {
        bottomTab(newValue) {
            //给这个赋值是关键
            this.myBottomTab = newValue
        }
    }
}
</script>

<style scoped lang="less">
.icons {
    display: flex;
    flex-wrap: nowrap;

    .icon-group {
        flex: 1;
        text-align: center;
    }

    p {
        color: #8c939d;
        font-size: small;
    }
}

.icon-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    width: 64px;
    height: 64px;
    display: inline-block;
}

.icon-uploader:hover {
    border-color: #409EFF;
}

.icon-uploader-plus {
    font-size: 28px;
    color: #8c939d;
    width: 64px;
    height: 64px;
    line-height: 64px;
    text-align: center;
    // background-color: #409EFF;
}

.icon {
    width: 64px;
    height: 64px;
    display: block;
}
</style>